import { useEffect, useState } from "react";
import AudiosService from "../Services/Audios";
import WithoutLyrics from "../Images/audiolyrics.svg";
import WithLyrics from "../Images/audiowithoutlyrics.svg";
import { Breadcrumbs } from "./E-BooksComponent";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import imgpause from "../assets/audioPlayer/img/yellowplay.svg";
import imgdownload from "../Images/downloadpravachan.svg";
import ListPagination from "../Components/ListPagination";
import Loader from "./Loader";
import { LogInModel } from "./LoginModel";
import i18n from "../i18n";
import "../Styles/Audios.css";

const DailySatsangPage = () => {
    const UserIdentity = localStorage.getItem("UserId") as any;
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [podcastData, setPodcastData] = useState<any[] | undefined | any>(undefined);
    const [logIn, setLogIn] = useState<boolean>(false);
    const [ItemtoPlay, setItemtoPlay] = useState<any>(null);

    const closeModal = () => {
        setLogIn(false);
    };

    const [refresh, setRefresh] = useState(false);
    const [pagination, setPagination] = useState({
        pageNo: 1,
        recordsPerPage: 12,
        totalRecords: 0,
    });

    var timestamp = new Date().getTime();
    const encoded = btoa(timestamp.toString());

    const [loading, setLoading] = useState(true);

    const handleLoginStateChange = (newState: any) => {
        if (newState === true && ItemtoPlay) {
            localStorage.setItem("type", "DailySatsang");
            const slugToUse = ItemtoPlay.audioslug || ItemtoPlay.description || "";
            console.log("slugToUse", slugToUse);
            navigate(`/DailySatsang/${encodeURIComponent(slugToUse)}`, {
                state: {
                    audioId: ItemtoPlay.audioId,
                    audioslug: slugToUse,
                    index: ItemtoPlay.index,
                    pageNum: ItemtoPlay.pageNum,
                },
            });
            setItemtoPlay(null); // Clear the item to play
        }
    };

    const downloadDailySatsang = (pravachanPath: any) => {
        const imageUrl = pravachanPath;
        const link = document.createElement('a');
        link.href = imageUrl; link.download = 'image.jpg';
        document.body.appendChild(link); link.click();
        document.body.removeChild(link);
    };

    useEffect(() => {
        setRefresh(false);
        const fetchData = async () => {
            try {
                const response = await AudiosService.getDailySatsang(
                    "",
                    pagination.pageNo === 0
                        ? 0
                        : pagination.recordsPerPage * pagination.pageNo - 12,
                    pagination.recordsPerPage,
                    "",
                    "",
                    "",
                    "",
                    0
                )
                const res = await response;
                setPodcastData(res.result?.items);
                setPagination({
                    ...pagination,
                    totalRecords: res.result?.totalRecords,
                });
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setLoading(false); // Hide loader after fetching
            }
        }
        fetchData();
    }, [refresh, i18n.language])

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);


    const style:any=()=>{
        return(
            <h1 style={{fontWeight:700,fontSize:"36px"}}>{t("daily_satsang_tr")}</h1>
        )
    }
    
    return (
        
        <div style={{ marginBottom: "20px" }}>

<div style={{ backgroundColor: "rgb(255, 237, 188)", padding: "0px 0px 0px 0px",marginTop:"-60px" }}>
      <div style={{ width: "100%", maxWidth: "1200px", margin: "0 auto", padding: "0 10px",backgroundColor:"rgb(255, 237, 188)" }}>
            <div
              style={{
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "space-between",
                gap: "20px",
                flexWrap: "wrap",
                padding: "28px 0 16px",
              }}
            >
              <div style={{ flex: "0 1 260px", minWidth: "220px" }}>
                <div style={{ padding: "8px 0" }}>
                  <h1 style={{ color: "#cf2c24", fontSize: "40px", margin: 0, fontWeight: 700,marginTop:"70px", textShadow: "0px 0px 4px rgba(255,255,255,0.9)" }}>
                    {t("daily_satsang_tr")}
                  </h1>
                  <div style={{ marginTop: "10px", fontSize: 19,fontWeight:600,color:"rgb(45, 42, 41)" }}>
                    <Link to="/" style={{ marginRight: "8px", color: "#2d2a29" }}>{t("Home_tr")}</Link>
                    <span style={{ margin: "0 6px" }}>/</span>
                    <span>{t("daily_satsang_tr")}</span>
                  </div>
                </div>
              </div>

              <div
                style={{
                  width: "1px",
                  minHeight: "100px",
                  background: "#facc6f",
                  marginTop: "65px",
                }}
              />

              <div style={{ flex: "1 1 520px", minWidth: "300px" }}>
                <h2
                  style={{
                    textAlign: "center",
                    color: "rgb(228, 121, 7)",
                    textShadow: "0px 0px 4px rgba(255,255,255,0.9)",
                    fontWeight: 600,
                    margin: 0,
                    paddingTop:"30px",
                    // marginb:"-10px",
                  }}
                >
                  {t("Daily_Satsang_title_tr")}
                </h2>

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginTop: "8px",
                    gap: "10px",
                    flexWrap: "wrap",
                  }}
                >
                  <div style={{ width: "250px", height: "1px", background: "#E5B15A" }} />
                  <svg
                    width="26"
                    height="18"
                    viewBox="0 0 26 18"
                    style={{ margin: "0 12px" }}
                  >
                    <rect x="1" y="7" width="2" height="4" rx="1" fill="#E5B15A" />
                    <rect x="5" y="4" width="2" height="10" rx="1" fill="#E5B15A" />
                    <rect x="9" y="1" width="2" height="16" rx="1" fill="#E5B15A" />
                    <rect x="13" y="4" width="2" height="10" rx="1" fill="#E5B15A" />
                    <rect x="17" y="1" width="2" height="16" rx="1" fill="#E5B15A" />
                    <rect x="21" y="4" width="2" height="10" rx="1" fill="#E5B15A" />
                  </svg>
                  <div style={{ width: "250px", height: "1px", background: "#E5B15A" }} />
                </div>

                <p
                  style={{
                    fontSize: 17,
                    color: "#4a4036",
                    textShadow: "0px 0px 4px rgba(255,255,255,0.8)",
                    // margin: "25px 0 -10px",
                    margin:"18px 0px 0px 0px",
                    width: "100%",
                    lineHeight: 1.75,
                    whiteSpace: "normal",
                    overflowWrap: "break-word",
                    textAlign: "justify",
                  }}
                >
                  {t("Daily_Satsang_description_tr")}
                </p>
              </div>
            </div>
      </div>
  </div>
  
            <div>
                <div className="containers">
                    <div
                        className="filter1"
                        style={{ margin: "5px 0" }}
                    >
                        <span>
                            {t("Total_Records_tr")} : {pagination?.totalRecords}
                        </span>
                    </div>
                    {podcastData?.length >= 0 ?
                        <div className="row">
                            <div className="podcastbox">
                                {podcastData?.map((data: any, i: number) => {
                                    return (
                                        <div key={`data-${data.id}`}>
                                            <div className="sidebarmargin">
                                                <div
                                                    className="pravchanBox"
                                                    style={{ display: "flex", padding: "15px 20px", cursor: "pointer" }}
                                                >
                                                    <div style={{ marginRight: "25px" }}>
                                                        <a>
                                                            <img
                                                                className="audioicon"
                                                                src={
                                                                    data.lyricsHash != null
                                                                        ? WithLyrics
                                                                        : WithoutLyrics
                                                                }
                                                                onError={(e) => {
                                                                    e.currentTarget.src = WithoutLyrics;
                                                                }}
                                                                alt={data.name}
                                                                title={data.name}
                                                                onClick={() => {
                                                                        if (UserIdentity) {
                                                                        localStorage.setItem("type", "DailySatsang")
                                                                        const slugToUse = data?.slug || data?.description || "";
                                                                        console.log("slugToUse", slugToUse);
                                                                        navigate(`/DailySatsang/${encodeURIComponent(slugToUse)}`, {
                                                                            state: {
                                                                                audioId: data?.id,
                                                                                audioslug: slugToUse,
                                                                                index: i,
                                                                                pageNum: pagination.pageNo,
                                                                            },
                                                                        });
                                                                    } else {
                                                                        setItemtoPlay({
                                                                            description: data?.description,
                                                                            audioId: data?.id,
                                                                            audioslug: data?.slug || data?.description,
                                                                            index: i,
                                                                            pageNum: pagination.pageNo,
                                                                        });
                                                                        setLogIn(true);
                                                                    }
                                                                }}
                                                            />
                                                        </a>
                                                    </div>
                                                    <div style={{ width: "100%" }}>
                                                        <a
                                                            style={{ cursor: "pointer" }}
                                                            onClick={() => {
                                                                const slugToUse = data?.slug || data?.description || "";

                                                                console.log("slug", data?.slug);
                                                                console.log("description", data?.description);

                                                                if (UserIdentity) {
                                                                    localStorage.setItem("type", "DailySatsang")
                                                                    navigate(`/DailySatsang/${encodeURIComponent(slugToUse)}`, {
                                                                        state: {
                                                                            audioId: data?.id,
                                                                            audioslug: slugToUse,
                                                                            index: i,
                                                                            pageNum: pagination.pageNo,
                                                                        },
                                                                    });
                                                                } else {
                                                                    setItemtoPlay({
                                                                        description: data?.description,
                                                                        audioId: data?.id,
                                                                        audioslug: slugToUse,
                                                                        index: i,
                                                                        pageNum: pagination.pageNo,
                                                                    });
                                                                    setLogIn(true);
                                                                }
                                                            }}
                                                        >
                                                            <p
                                                                style={{
                                                                    fontSize: "25px",
                                                                    paddingTop: "3px",
                                                                    fontWeight: "600",
                                                                    textAlign: "unset",
                                                                }}
                                                            >
                                                                <h3 style={{fontSize:"22px"}}>
                                                                    {/* {data.name != null &&
                                                                data.name.length > 100
                                                                ? data.name.slice(0, 80) + "..."
                                                                : data.name} */}
                                                                    {data?.name}
                                                                </h3>
                                                            </p>
                                                            <div style={{ display: "grid" }}>
                                                                <label>{data.description}</label>
                                                                <label>{data.audioLength}</label>
                                                                {/* <label>{convertLengthToTime(data?.audioLength)}</label> */}
                                                            </div>
                                                        </a>
                                                    </div>
                                                    <div className="btns">
                                                        <div className="buttonres">
                                                            <a
                                                                id="download"
                                                                title="Download"
                                                                onClick={() => {
                                                                    if (UserIdentity) {
                                                                        downloadDailySatsang(data.audioPath != null
                                                                            ? data.audioPath + "?t=" + encoded + "&download_attachment=true"
                                                                            : "no record found")
                                                                    } else {
                                                                        setLogIn(true);
                                                                    }
                                                                }}
                                                            >
                                                                <img
                                                                    alt="download"
                                                                    src={imgdownload}
                                                                    className="downloadbtn"
                                                                ></img>
                                                            </a>
                                                        </div>
                                                        <div
                                                            style={{
                                                                cursor: "pointer",
                                                                paddingLeft: "5px",
                                                            }}
                                                        >
                                                            <img
                                                                alt=""
                                                                onClick={() => {
                                                                        localStorage.setItem("type", "DailySatsang")
                                                                        const slugToUse = data?.slug || data?.description || "";
                                                                        console.log("slugToUse", slugToUse);
                                                                        if (UserIdentity) {
                                                                            navigate(`/DailySatsang/${encodeURIComponent(slugToUse)}`, {
                                                                                state: {
                                                                                    audioId: data.id,
                                                                                    audioslug: slugToUse,
                                                                                    index: i,
                                                                                    pageNum: pagination.pageNo,
                                                                                },
                                                                            });
                                                                        } else {
                                                                            setItemtoPlay({
                                                                                description: data?.description,
                                                                                audioId: data?.id,
                                                                                audioslug: slugToUse,
                                                                                index: i,
                                                                                pageNum: pagination.pageNo,
                                                                            });
                                                                            setLogIn(true);
                                                                        }
                                                                    }}
                                                                title="Play"
                                                                src={imgpause}
                                                                className="playbtn"
                                                            ></img>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }
                                )}
                            </div>
                            <div className="col-12" style={{ marginTop: "30px", display: pagination.totalRecords <= 12 ? "none" : "block" }}>
                                <ListPagination
                                    totalRecords={pagination.totalRecords}
                                    recordsPerPage={pagination.recordsPerPage}
                                    currentPage={pagination.pageNo}
                                    onClick={(p) => {
                                        setPagination({
                                            ...pagination,
                                            pageNo: p,
                                        });
                                        setRefresh(true);
                                    }}
                                />
                            </div>
                        </div>
                        :
                        <div className="ebooks-category resultnotfound">
                            {loading && <Loader loading={loading} />}
                            {t("result_not_found_tr")}
                        </div>
                    }
                </div>
                <LogInModel opens={logIn} onCloses={closeModal} onLoginStateChange={handleLoginStateChange} />
            </div>
        </div>
    )
}
export default DailySatsangPage;